import React, {Component} from 'react'
import {connect} from 'react-redux'
import FJLocalStore from "../../../store/FJLocalStore";
import FJButtonSemicircle from "../../../common/component/button-semicircle/FJButtonSemicircle";
import FJPopover from "../view/FJPopover";
import {FJPreviewAction, FJSaveAction} from "../../../redux/action/FJRoot.action";
// import FJEvent from "../../../core/FJEvent";
import FJEventConstant from "../../../constant/FJEventConstant";
import FJSaveStore from "../../../store/FJSaveStore";
import FJUtil from "../../../util/FJUtil";
import FJPaymentAction from "../../../redux/action/FJPayment.action";
import FJViewConstant from "../../../constant/FJViewConstant";

class FJSaveContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      saveStatus: FJSaveStore.status,
    }
  }

  componentDidMount() {
    let {CHANGE_SAVE_STATUS, SAVE_ONLINE_ERROR} = FJEventConstant;
    this.changeStatusUnsubscribtion = window.FJEvent.subscribe(CHANGE_SAVE_STATUS, (status) => {
      this.setState({saveStatus: status});
    });
    this.saveFailUnsubscribtion = window.FJEvent.subscribe(SAVE_ONLINE_ERROR, (data) => {
      let {error, isFlushSaving} = data;
      if (isFlushSaving) {
        let code = Number(error.message);
        if (code === 341 && this.props.paymentLevel === FJViewConstant.USER_PAYMENT_FREE) {
          this.props.setShowPopoverType(2);
        } else {
          this.props.showSaveFailModal();
        }
      }
    });

    this.showSaveTipModalUnsubscribtion = window.FJEvent.subscribe('showSaveTipModal', () => {
      this.props.setShowPopoverType(1)
    });
  }

  componentWillUnmount() {
    this.changeStatusUnsubscribtion();
    this.saveFailUnsubscribtion();
    this.showSaveTipModalUnsubscribtion();
  }

  /**
   * @description 触发保存
   */
  handleClick = () => {

    let {SAVE} = FJSaveStore.SAVE_STATUS;
    if (this.state.saveStatus !== SAVE) {
      return
    }
    this.props.stop();
    FJUtil.doSave();
  };

  calcSaveText = () => {
    let text = '';
    let {SAVE, SAVED, SAVING} = FJSaveStore.SAVE_STATUS;
    switch (this.state.saveStatus) {
      case SAVE:
        text = FJLocalStore._('save');
        break;
      case SAVED:
        text = FJLocalStore._('saved');
        break;
      case SAVING:
        text = FJLocalStore._('saving');
        break;
      default:
    }

    return text;
  };

  cancel = () => {
    this.props.setShowPopoverType(0);
  };

  render() {
    let {
      className,
      disabledClass,
      showPopoverType,
      textClass
    } = this.props;

    let {
      saveStatus,
    } = this.state;

    let content;
    let btnMsg;
    switch (showPopoverType) {
      case 1:
        content = FJLocalStore._('save-project-in-case-of-data-loss');
        btnMsg = [
          {
            btnText: FJLocalStore._('got-it'),
            btnClassName: "orange_btn",
            onClick: () => {
              this.cancel();
            },
          },
        ]
        break;
      case 2:
        content = FJLocalStore._('manager-to-save');
        btnMsg = [
          {
            btnText: FJLocalStore._('manage'),
            btnClassName: "gray_btn",
            onClick: () => {
              this.cancel();
              if (process.env.SERVE_ENV === 'release') {
                window.open('https://www.flexclip.com/editor/my-projects');
              } else if (process.env.SERVE_ENV === "dev") {
                window.open('https://www.smartvideomaker.com/editor/my-projects');
              }
            },
          },
          {
            btnText: FJLocalStore._('upgrade'),
            btnClassName: "green_btn",
            onClick: () => {
              this.cancel();
              this.props.upgrade();
            },
          },
        ]
        break;
      default:
        content = '';
        btnMsg = [];
    }

    return (
      <div style={{display: 'inline-block', position: 'relative'}}>
        <FJButtonSemicircle text={this.calcSaveText()}
                            disabled={saveStatus !== FJSaveStore.SAVE_STATUS.SAVE}
                            className={className}
                            disabledClass={disabledClass}
                            onClick={this.handleClick}
                            textClass={textClass}
                            type='default'
        />
        <FJPopover isShow={showPopoverType}
                   onCancel={this.cancel}
                   content={content}
                   btnMsg={btnMsg}
        />
      </div>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    showPopoverType: state.save.showPopoverType,
    paymentLevel: state.payment.paymentLevel,
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    setShowPopoverType: function (type) {
      dispatch(FJSaveAction.setShowPopoverTypeAction(type));
    },
    showSaveFailModal: function () {
      dispatch(FJSaveAction.showSaveFailModalAction());
    },
    stop: function () {
      dispatch(FJPreviewAction.setVideoPauseAction());
    },
    upgrade: function (source) {
      dispatch(FJPaymentAction.upgradeLevelAction(source));
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJSaveContainer);
